package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_06_06_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-06-06")
@Composable
public fun Log_2026_06_06(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Real-World Rogues Strike Again!",
        ogTitle = "Real-World Rogues Strike Again!",
        date = LocalDate(2_026, 6, 6),
        aiHint = "Image, title, and description are jokes but also reference the 'real world' not events in the D&D campaign.",
        ogDescription = "Can't you just tell these pesky international criminals to stop? It's rude to get in the way of people's D&D campaigns!",
        ogImage = "images/robberD20_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "shimmer-32", dateString = "Shimmer 32")
        Log_2026_06_06_Day_1()
        SessionMediaItem(
            image = "images/robberD20.webp",
            linkImage = "images/robberD20.webp",
            width = 916,
            height = 634,
        )
    }
}
